import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useQuery } from '../../../../hooks';
import { getEmbedThemeFromUrl } from '../../../../hooks/embedTheme';
import { WorkflowRunner } from '../../../../components';

import './Workflow.css';

const EMBED_THEME = getEmbedThemeFromUrl();

const Workflow = props => {
    const { workflow_id }     = useParams();
    const { tkt_instance_id } = props;
    const { isEmbedded }      = useSelector(state => state.ui);
    const themeClass = EMBED_THEME === 'dark' ? 'theme-dark' : 'theme-light';

    // grab context default values from url
    // query, if any
    const context = useQuery();
    const resumeToken = context?.token || context?.resume_token || null;
    const resumeRunId = context?.run_id || null;
    const resumeEvent = context?.event || null;
    const resumeCartId = context?.cart_id || null;
    const hasResumeParams = Boolean(resumeToken || resumeRunId);

    return (
        <div className={`Workflow ${isEmbedded ? 'embedded' : ''} ${themeClass}`}>
            <div className="wrapper">
                <div className={`container form-shell ${isEmbedded ? '' : 'border rounded bg-white p-3'}`}>
                    {(workflow_id || hasResumeParams) && tkt_instance_id && (
                        <WorkflowRunner
                            workflow_id={ workflow_id }
                            tkt_instance_id={ tkt_instance_id }
                            default_context={ context }
                            show_system_messages={ false }
                            resume_token={ resumeToken }
                            resume_run_id={ resumeRunId }
                            resume_event={ resumeEvent }
                            resume_cart_id={ resumeCartId }
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default Workflow;
